// FloatingAssistant — bottom-right chat bubble.
// Mounted globally in App.js; renders on every authenticated page.
// Closed by default; opens a panel anchored to bottom-right.
import React, { useState } from "react";
import { Bot, X } from "lucide-react";
import AssistantPanel from "./AssistantPanel";

export default function FloatingAssistant({ role }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Bubble */}
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Open Lifted AI Assistant"
          data-testid="floating-assistant-open"
          className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-lifted-green text-black shadow-2xl shadow-lifted-green/40 hover:scale-105 transition-transform flex items-center justify-center border-2 border-black"
        >
          <Bot size={22} />
        </button>
      )}

      {/* Panel */}
      {open && (
        <div
          className="fixed bottom-5 right-5 z-50 w-[min(94vw,420px)] max-h-[80vh] shadow-2xl shadow-black/70 rounded-xl overflow-hidden"
          data-testid="floating-assistant-panel"
        >
          <div className="absolute top-2 right-2 z-10">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-7 h-7 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center border border-white/10"
              aria-label="Close assistant"
              data-testid="floating-assistant-close"
            >
              <X size={14} />
            </button>
          </div>
          <AssistantPanel
            surface="floating"
            role={role}
            testid="floating-assistant"
          />
        </div>
      )}
    </>
  );
}
